import { createSelector } from 'reselect';

const selectCache = (state: any) => state.responseCache;

export const selectResponseInfo = createSelector(
  selectCache,
  (cache: any) => cache.responseAttachmentsData
);

export const selecteResponseLoading = createSelector(
  selectCache,
  (cache: any) => cache.loadingResponseAttachments
);

export const selectResponseError = createSelector(
  selectCache,
  (cache: any) => cache.errorResponseAttachments
);

export const selectResponseAttachmentDownloadLink = createSelector(
  selectCache,
  (cache: any) => cache.downloadLink
);

export const selectResponseAttachmentDownloadLinkLoading = createSelector(
  selectCache,
  (cache: any) => cache.loadingDownloadLink
);

export const selectResponseAttachmentsDownloadAll = createSelector(
  selectCache,
  (cache: any) => cache.downloadAll
);

export const selectResponseAttachmentsDownloadAllLoading = createSelector(
  selectCache,
  (cache: any) => cache.loadingDownloadAll
);
